import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';

type MarkerTextPropsType = {
    list: { description: string }[];
    listStages: { description: string }[];
};

const MarkerText = ({ list, listStages }: MarkerTextPropsType) => {
    return (
        <div className="aimed-marker-text">
            <FullWrapper>
                <div className="aimed-marker-textWrapper">
                    <div className="aimed-marker-textPirpleBlock">
                        <div className="aimed-marker-textParagraf">
                            Разработка и&nbsp;взаимодействие всех модулей платформы, отвечающих
                            за&nbsp;точность и&nbsp;скорость сравнения данных во&nbsp;время
                            проведения конкурса с&nbsp;эталонами, стали основой третьего этапа
                            проекта.
                        </div>
                    </div>
                    <div className="aimed-marker-textList">
                        {list &&
                            list.map(({ description }) => (
                                <div
                                    className="aimed-marker-textParagraf"
                                    key={description}
                                    dangerouslySetInnerHTML={{ __html: description }}
                                ></div>
                            ))}
                    </div>
                    <div className="aimed-marker-textPirpleBlock">
                        <div className="aimed-marker-textParagraf">
                            Четвертый этап&nbsp;&mdash; это подготовка к&nbsp;старту отборочных
                            и&nbsp;финальных конкурсных испытаний, где основной фокус был
                            на&nbsp;обеспечении работоспособности платформы
                            и&nbsp;ее&nbsp;отказоустойчивость в&nbsp;день проведения испытаний
                            в&nbsp;онлайн-режиме.
                        </div>
                    </div>
                    <div className="aimed-marker-textList">
                        {listStages &&
                            listStages.map(({ description }) => (
                                <div
                                    className="aimed-marker-textParagraf"
                                    key={description}
                                    dangerouslySetInnerHTML={{ __html: description }}
                                ></div>
                            ))}
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default MarkerText;
